<template>
  <div
    v-if="currentUserId"
    :class="[$style.container, isOwn && $style.containerOwn, selectable && $style.containerSelectable, selected && $style.containerSelected]"
    @click="onSelect"
  >
    <div :class="$style.avatar">
      <app-avatar
        :name="userName"
        :img="userAvatar"
        size="35px"
      />
    </div>
    <div :class="$style.body">
      <div :class="$style.text">
        <slot />
      </div>
      <div :class="$style.date">{{ message.created_at | moment }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:     "ChatMessageWrapper",
  props:    ['message', 'selectable', 'selected'],
  computed: {
    isOwn() {
      return this.message.user && this.currentUserType === this.message.user.type_user;
    },
    currentUserType() {
      return this.$store.getters['appUser/type'];
    },
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },
    currentUserName() {
      return this.$store.getters['appUser/name'];
    },
    currentUserAvatar() {
      return this.$store.getters['appUser/avatar'];
    },
    userAvatar() {
      return this.$options.filters.filePath(this.message.user ? this.message.user.avatar : 'default_avatar.png');
    },
    userName() {
      return this.message.user ? this.message.user.name : 'unknown';
    },
  },
  methods:  {
    onSelect() {
      if (!this.selectable) return;
      const selection = window.getSelection();
      if (selection.type === "Range") return;
      this.$emit('select', this.message);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  padding: 5px 60px 5px 15px;
  //max-width: 90%;

  @media screen and(max-width: 576px) {
    max-width: 100%;
  }
}

.body {
  max-width: calc(100% - 35px);
}

.avatar {
  margin-right: 10px;
}

.text {
  //background: #f8f9fa;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
  position: relative;
  margin-top: 5px;
  background: #24417A;
  color: #fff;
  @include anim(.1s);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 100%;
    border-top: 0px solid transparent;
    border-right: 9px solid #24417A;
    border-bottom: 12px solid transparent;
  }
}

.date {
  font-size: .75rem;
  margin-top: 5px;
}

.containerOwn {
  flex-direction: row-reverse;
  margin-left: auto;
  padding: 5px 15px 5px 60px;

  .text {
    background: #F0F0F9;
    border-radius: 4px 0 4px 4px;
    color: rgba(var(--app-text), 1);

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      border-top: 0px solid transparent;
      border-left: 9px solid #F0F0F9;
      border-bottom: 12px solid transparent;
      border-right: none;
    }
  }

  .avatar {
    margin-right: 0;
    margin-left: 10px;
  }

  .date {
    text-align: right;
  }
}

.containerSelectable {
  cursor: pointer;
  @include anim(.05s);

  &:hover {
    background: rgba(#F0F0F9, 0.4);

    &.containerOwn {
      .text {
        background: #E8E8F6;

        &:after {
          border-left-color: #E8E8F6;
        }
      }
    }
  }
}

.containerSelected {
  &, &:hover {
    background: rgba(#F0F0F9, 0.9);
  }

  &.containerOwn {
    &, &:hover {
      .text {
        background: #E4E4F4;

        &:after {
          border-left-color: #E4E4F4;
        }
      }
    }
  }
}

</style>
